"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");
/**
 * Class to represent a dropdown.
 *
 * @extends {React.Component<ICategorySelectorProps, any>}
 */


var CategorySelector =
/** @class */
function (_super) {
  __extends(CategorySelector, _super);

  function CategorySelector(props) {
    return _super.call(this, props) || this;
  }

  CategorySelector.prototype.render = function () {
    return this.props.categories && React.createElement(semantic_ui_react_1.Dropdown, {
      fluid: true,
      onChange: this.props.onCategoryChange,
      options: __spread(this.props.categories.map(function (cat) {
        return {
          key: cat,
          text: cat,
          value: cat
        };
      })),
      placeholder: 'Select Category',
      search: true
    });
  };

  CategorySelector.defaultProps = {
    categories: []
  };
  return CategorySelector;
}(React.Component);

exports.CategorySelector = CategorySelector;